function checkWizzyConfigAndUpdate() {
  window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] = "#MainContent";

  if (window.wizzyConfig) {
    if (window.matchMedia("(max-width: 768px)").matches) {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: 'input[name="q"]',
        type: "text",
      };
    } else {
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: "#wizzy-search-input-desktop",
        type: "text",
      };
    }
    clearInterval(interval);
  }
}

const interval = setInterval(checkWizzyConfigAndUpdate, 10);

if (window.innerWidth < 748) {
  document.body.addEventListener("click", (event) => {
    const target = event.target;

    if (
      target.closest(
        ".icons--inline.search-show.alt-focus.header-link.header-link--button"
      )
    ) {
      const searchInput = document.getElementById("searchInput");
      searchInput.style.display = "block";
      searchInput.click();
    }

    if (target.closest(".wizzy-search-back")) {
      document.getElementById("top-search-wrapper").click();
      document.getElementById("searchInput").style.display = "none";
    }

    if (
      target.closest(
        `.wizzy-autocomplete-wrapper .wizzy-autocomplete-suggestions 
         .autocomplete-item .wizzy-recent-search-clear-icon, 
         .wizzy-autocomplete-wrapper .wizzy-autocomplete-suggestions 
         .wizzy-recent-search-clear-all`
      )
    ) {
      setTimeout(() => {
        document.querySelector("input#searchInput").click();
      }, 100);
    }
  });
} else {
  document.body.addEventListener("click", (event) => {
    if (
      event.target.matches(".wizzy-facet-head") ||
      event.target.matches(".facet-head-title")
    ) {
      const closestBlock = event.target.closest(
        ".wizzy-filters-facet-block.facet-block-top"
      );
      const filterBox = document.querySelector(
        ".wizzy-search-filters-list-top"
      );

      if (closestBlock && filterBox) {
        const left = closestBlock.offsetLeft;
        const top = closestBlock.offsetTop;
        const height = filterBox.offsetHeight;

        document.querySelectorAll(".wizzy-facet-list").forEach((el) => {
          el.style.left = `${left}px`;
          el.style.top = `${top - height + 50}px`;
        });
      }
    }
  });
}

window.onWizzyScriptLoaded = function () {
  const { events, pageStore } = window.wizzyConfig;

  events.registerEvent(events.allowedEvents.BEFORE_LAZY_INIT, (data) => {
    data.endpoints.common = "https://uranus-api.wizsearch.in";
    return data;
  });

  events.registerEvent(events.allowedEvents.BEFORE_INIT, (data) => {
    data.search.configs.facets.leftFacets.defaultCollapsed = true;
    data.search.configs.facets.leftFacets.firstLeftDefaultOpened = false;
    data.search.configs.facets.leftFacets.mobileCollapsible = true;
    data.filters.configs.keepOpenedInMobileAfterApply = true;
    data.search.view.templates.facets.gridFilterCommon =
      "#wizzy-grid-facet-block";
    data.gridFilters.enabled = true;
    data.endpoints.common = "https://uranus-api.wizsearch.in";
    return data;
  });

  events.registerEvent(
    events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    (data) => {
      data.forEach((product) => {
        const pricingArray = [];

        product.attributes.forEach((attr) => {
          if (
            attr.id === "product_tags" &&
            attr.values[0].value[0].includes("badge:best seller")
          ) {
            product.bestSeller = 1;
          }

          if (attr.id === "product_variant_prices") {
            attr.values.forEach((pr) => {
              pricingArray.push(pr.value[0]);
            });
          }
        });

        const maxPrice = Math.max(...pricingArray);
        const minPrice = Math.min(...pricingArray);

        if (minPrice < maxPrice && product.sellingPrice === minPrice) {
          product.hasPriceRange = true;
        }
      });

      return data;
    }
  );

  if (window.innerWidth < 748) {
    events.registerEvent(
      events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      (data) => {
        document.querySelector(".wizzy-icon").click();
        document.getElementById("top-search-wrapper").click();
        document.getElementById("searchInput").style.display = "none";
        // document.querySelector('.wizzy-search-form mf-initial').style.display = 'none';
        document.querySelector('.wizzy-search-back').click();
        return data;
      }
    );

    events.registerEvent(
      events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
      (payload) => {
        document
          .querySelectorAll(".wizzy-filters-facet-block")
          .forEach((element) => {
            element.addEventListener("click", (e) => {
              document
                .querySelectorAll(".wizzy-filters-facet-block")
                .forEach((el) => {
                  if (el !== e.currentTarget) {
                    el.classList.add("collapsed");
                  }
                });
            });
          });

        const searchQuery = document.querySelector(".wizzy-search-query");
        if (searchQuery) {
          searchQuery.innerText = pageStore.searchedResponse.filters.q;
        }

        return payload;
      }
    );
  }

  events.registerEvent(events.allowedEvents.VIEW_RENDERED, (payload) => {
    const searchQuery = document.querySelector(".wizzy-search-query");
    if (searchQuery) {
      searchQuery.innerText = `"${pageStore.searchedResponse.filters.q}":`;
    }
    return payload;
  });

  events.registerEvent(events.allowedEvents.BEFORE_SEARCH_EXECUTED, (payload) => {
    console.log("BEFORE_SEARCH_EXECUTED triggered");
    return payload;
  });
};
